import { render, staticRenderFns } from "./OssConfigModal.vue?vue&type=template&id=702aeb02&"
import script from "./OssConfigModal.vue?vue&type=script&lang=js&"
export * from "./OssConfigModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports